import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { downloadContentForManualMatchFailure, downloadContentForManualMatchReset, downloadContentForManualMatchSuccess } from '../../actions/manualVerificationActions/downloadContentForManualMatchActions';

function* downloadContentForManualMatch({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.downloadContentForManualMatch + `?contentPath=${payload.contentPath}`,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("DOWNLOAD_CONTENT_FOR_MANUAL_MATCH_SUCCESS status :", response.data.status);
        console.log("DOWNLOAD_CONTENT_FOR_MANUAL_MATCH_SUCCESS data :", response.data.response);
        console.log("DOWNLOAD_CONTENT_FOR_MANUAL_MATCH_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            downloadContentForManualMatchSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (response?.data?.status === 200) {
            const link = document.createElement('a');
            link.href = response?.data?.response;
            link.target = '_blank';
            link.download = '';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            yield put(downloadContentForManualMatchReset());
        }
    } catch (error) {
        console.log('====================================');
        console.log("DOWNLOAD_CONTENT_FOR_MANUAL_MATCH_FAILURE status :", error?.response?.status);
        console.log("DOWNLOAD_CONTENT_FOR_MANUAL_MATCH_FAILURE data:", error?.response?.data);
        console.log("DOWNLOAD_CONTENT_FOR_MANUAL_MATCH_FAILURE error :", error);
        console.log('====================================');
        yield put(downloadContentForManualMatchFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* downloadContentForManualMatchSaga() {
    yield takeLatest(actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_MATCH_REQUEST, downloadContentForManualMatch);
}

export default downloadContentForManualMatchSaga;
